// NOTICE!! THIS IS REQUIRED TO MAKE YOUR NETO SHOPPING CART WORK
// DO NOT REMOVE UNLESS YOU REALLY KNOW WHAT YOU ARE DOING

var nCustom = {
  vars: {
    focused: $('body'),
    lastFocused: $('body'),
  },
  funcs: {
    initPageFuncs: function () {
      // Ajax Wish List
      $.addToWishList({
        class: 'wishlist_toggle',
        textclass: 'wishlist_text',
        htmlon: '<svg><use xlink:href="#icon-wishlist"></use></svg>',
        htmloff: '<svg><use xlink:href="#icon-wishlist-full"></use></svg>',
        tooltip_css: 'whltooltips',
        imageon: '',
        imageoff: '',
      });
      // Ajax Add To Cart
      $.addToCartInit({
        cart_id: 'cartcontents',
        target_id: 'cartcontentsheader',
        image_rel: 'itmimg',
      });
      // Renders the instant search results - edit design of ajax results here
      $.initSearchField({
        result_header: '<ul class="nav nav-list">',
        result_body:
          '<li><a href="##url##" search-keyword="##keyword##"><img border="0" src="##thumb##" width="36" height="36"/><span class="title">##model##</span></a></li>',
        result_footer: '</ul>',
        category_header: '<ul class="nav nav-list">',
        category_body:
          '<li><a href="##url##"><span class="thumb"><img border="0" src="##thumb##" width="36" height="36"/></span><span class="title">##fullname##</span> <span class="label label-default">##typename##</span></a></li>',
        category_footer: '</ul>',
      });
    },
    // For child product multi-add to cart function
    checkValidQty: function () {
      // var found = 0;
      // $('#multiitemadd :input').each(function() {
      // 	if ($(this).attr('id').match(/^qty/)) {
      // 		if ($(this).val() > 0) {
      // 			found = 1;
      // 		}
      // 	}
      // });
      // if (found == 0) {
      // 	$.nPopupBox('Please specify a quantity before adding to cart');
      // 	return false;
      // }
      return true;
    },
    // Capture the last item focused
    updateFocused: function () {
      nCustom.vars.lastFocused = nCustom.vars.focused;
    },
    // Place focus on popup
    popupFocus: function () {
      var popUp = document.getElementById('npopupDesc');
      // Configures the observer
      var config = { childList: true };
      // Create an observer instance
      var popUpObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          // Initial observer
          if (mutation.addedNodes['0']) {
            nCustom.funcs.updateFocused();
            // focus on the popup
            $(popUp).attr('tabindex', '-1').trigger('focus');
          } else {
            $(popUp).attr('tabindex', '').trigger('focus');
            // Observer closing popup
            $(nCustom.vars.lastFocused).trigger('focus');
          }
        });
      });
      // Pass in the target node, as well as the observer options
      if (popUp) {
        popUpObserver.observe(popUp, config);
      }
    },
    buttonLoading: function () {
      var loadingText = $(this).attr('data-loading-text');
      var originalText = $(this).html();
      $(this).html(loadingText).addClass('disabled').prop('disabled', true);
      var pendingButton = this;
      setTimeout(function () {
        $(pendingButton)
          .html(originalText)
          .removeClass('disabled')
          .prop('disabled', false);
      }, 3000);
    },
    windowPopup: function (url, width, height) {
      // Calculate the position of the popup so it’s centered on the screen.
      var left = screen.width / 2 - width / 2,
        top = screen.height / 2 - height / 2;
      window.open(
        url,
        '',
        'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=' +
          width +
          ',height=' +
          height +
          ',top=' +
          top +
          ',left=' +
          left,
      );
    },
    // Will remove/add class from element
    classToggle: function (element, css, type) {
      if (type) {
        type == 'add' ? $(element).addClass(css) : $(element).removeClass(css);
      }
    },
  },
};

$(document).ready(function () {
  // Neto functionalty
  nCustom.funcs.initPageFuncs();
  nCustom.funcs.popupFocus();
  // Jquery Ui Date Picker
  $('.datepicker').datepicker({ dateFormat: 'dd/mm/yy' });
  // Carousel
  $('.carousel').carousel();
  // Tooltip
  $('[data-toggle="tooltip"]').tooltip();
});
// Capture the current element the user focused in
$(document).on('focusin', function () {
  nCustom.vars.focused = document.activeElement;
});
// Btn loading state
$(document).on('click', '.btn-loads', nCustom.funcs.buttonLoading);
// Social media share
$('.js-social-share').on('click', function (e) {
  e.preventDefault();
  nCustom.funcs.windowPopup($(this).attr('href'), 500, 300);
});
// Mobile menu
$('.nToggleMenu').on('click', function () {
  var toggleTarget = $(this).attr('data-target');
  $(toggleTarget).slideToggle();
});
// Invoice page
$('#cart_items').on('click', '[data-body-add]', function (e) {
  e.preventDefault();
  nCustom.funcs.classToggle('body', $(this).attr('data-body-add'), 'add');
});
$('#cart_items').on('click', '[data-body-remove]', function (e) {
  e.preventDefault();
  nCustom.funcs.classToggle('body', $(this).attr('data-body-remove'), 'remove');
});
$('#_jstl__buying_options').on(
  'click',
  '.js-notifymodal-in-stock',
  function (e) {
    e.preventDefault();
    // Get values
    var sku = $(this).attr('data-sku');
    var $wrapper = $('#notifymodal .checkbox');
    var $terms = $('#notifymodal .terms_box');
    var $helpText = $('#notifymodal .checkbox .help-block');
    // Validate form
    if (!$.isChecked($terms)) {
      $wrapper.addClass('has-error');
      $helpText.removeClass('hidden');
      return false;
    } else {
      $wrapper.removeClass('has-error');
      $helpText.addClass('hidden');
      // Dismiss modal
      $('#notifymodal').modal('hide');
      // Send information
      $.addNotifyBackInStock(sku, '');
      $terms.attr('checked', false);
      return true;
    }
  },
);
// Multi add child products
$('.multi-add').on('click', function () {
  $.addMultipleCartItems('multiitemadd');

  return false;
});

$(document).ready(function () {
  $.compatListInit({});
  $('.compatibility_list').change(function () {
    $.buildCompatList($(this));
  });
});

// Update Order Summary on Add to Cart
window.nAddItemCallbacks.push(updateOrderSummary);
window.nAddMultiItemsCallbacks.push(updateOrderSummary);
window.nRemoveItemCallbacks.push(updateOrderSummary);

// Update Order Summary
function updateOrderSummary() {
  $.load_ajax_template('_order_summary', {});
}

// ======================================================
// CART-AWARE PRODUCT QUANTITY
//
// Quantity controls represent DESIRED TOTAL in cart.
//
// Example:
// Cart = 8
// Control = 10
// Neto receives 2
//
// Cart = 8
// Control = 8
// Add is blocked because nothing needs adding.
// ======================================================

(function () {
  'use strict';

  var ADD_BUTTON_SELECTOR = '.jsAddBtns';

  var pendingAdds = new Map();

  // --------------------------------------------------
  // HELPERS
  // --------------------------------------------------

  function normaliseSku(sku) {
    return String(sku || '')
      .trim()
      .toLowerCase();
  }

  function getCartItems() {
    if (
      typeof window.jQuery === 'undefined' ||
      typeof $.getCartCache !== 'function'
    ) {
      return [];
    }

    var cart = $.getCartCache() || [];

    if (!Array.isArray(cart)) {
      try {
        cart = Object.values(cart);
      } catch (e) {
        return [];
      }
    }

    return cart;
  }

  function getCartQty(sku) {
    var wantedSku = normaliseSku(sku);

    if (!wantedSku) {
      return 0;
    }

    var cart = getCartItems();
    var totalQty = 0;

    cart.forEach(function (item) {
      if (!item) return;

      var cartSku = item.SKU || item.sku || item.parent_sku || '';

      if (normaliseSku(cartSku) !== wantedSku) {
        return;
      }

      var qty = parseInt(item.baseqty || item.qty || item.quantity || 0, 10);

      if (!isNaN(qty)) {
        totalQty += qty;
      }
    });

    return totalQty;
  }

  function getSkuFromElement(element) {
    if (!element) {
      return '';
    }

    var skuElement = element.closest('[data-sku]');

    if (skuElement && skuElement.dataset.sku) {
      return skuElement.dataset.sku;
    }

    var wrapper = element.closest('[data-qty-select-combo]');

    if (wrapper && wrapper.dataset.sku) {
      return wrapper.dataset.sku;
    }

    var parent = element.closest('.product-box, form, [data-product]');

    if (parent) {
      var qty = parent.querySelector(
        '.js-neto-qty[data-sku], .jsQtyInput[data-sku]',
      );

      if (qty && qty.dataset.sku) {
        return qty.dataset.sku;
      }
    }

    return '';
  }

  function getProductArea(button) {
    if (!button) {
      return null;
    }

    return (
      button.closest('.product-box') ||
      button.closest('[data-product]') ||
      button.closest('form') ||
      button.parentElement
    );
  }

  // --------------------------------------------------
  // GET DESIRED QTY FROM CURRENT UI
  // --------------------------------------------------

  function getDesiredQty(area, sku) {
    if (!area) {
      return 1;
    }

    // PDP
    var pdpQty = area.querySelector(
      '.jsQtyInput[data-sku="' + CSS.escape(sku) + '"]',
    );

    if (pdpQty) {
      var pdpValue = parseInt(pdpQty.value, 10);

      return isNaN(pdpValue) ? 1 : pdpValue;
    }

    // Listing qty wrapper
    var wrappers = area.querySelectorAll('[data-qty-select-combo][data-sku]');

    for (var i = 0; i < wrappers.length; i++) {
      var wrapper = wrappers[i];

      if (normaliseSku(wrapper.dataset.sku) !== normaliseSku(sku)) {
        continue;
      }

      var select = wrapper.querySelector('.qty-select-combo__select');

      var custom = wrapper.querySelector('.qty-select-combo__input');

      if (!select) {
        break;
      }

      if (select.value === 'custom' && custom) {
        var customValue = parseInt(custom.value, 10);

        return isNaN(customValue) ? 1 : customValue;
      }

      var selectedValue = parseInt(select.value, 10);

      return isNaN(selectedValue) ? 1 : selectedValue;
    }

    // Fallback Neto input
    var netoInputs = area.querySelectorAll('.js-neto-qty[data-sku]');

    for (var j = 0; j < netoInputs.length; j++) {
      var input = netoInputs[j];

      if (normaliseSku(input.dataset.sku) !== normaliseSku(sku)) {
        continue;
      }

      var value = parseInt(input.value, 10);

      return isNaN(value) ? 1 : value;
    }

    return 1;
  }

  // --------------------------------------------------
  // FIND REAL NETO QTY INPUT
  // --------------------------------------------------

  function getNetoQtyInput(area, sku) {
    if (!area) {
      return null;
    }

    var inputs = area.querySelectorAll(
      '.js-neto-qty[data-sku], .jsQtyInput[data-sku]',
    );

    for (var i = 0; i < inputs.length; i++) {
      if (normaliseSku(inputs[i].dataset.sku) === normaliseSku(sku)) {
        return inputs[i];
      }
    }

    return null;
  }

  // --------------------------------------------------
  // OPTIONAL MESSAGE
  // --------------------------------------------------

  function showAlreadyInCart(button, qty) {
    /*
     * Replace this later with your own
     * message UI if you want.
     *
     * For now we only log it.
     */
    console.log('Already in cart:', qty);

    button.setAttribute('data-cart-qty', String(qty));
  }

  // --------------------------------------------------
  // INTERCEPT ADD BUTTON
  // --------------------------------------------------

  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest(ADD_BUTTON_SELECTOR);

      if (!button) {
        return;
      }

      var area = getProductArea(button);

      if (!area) {
        return;
      }

      var sku = getSkuFromElement(button);

      /*
       * Button may not itself sit below
       * data-sku, so look inside area too.
       */
      if (!sku) {
        var skuInput = area.querySelector(
          '.js-neto-qty[data-sku], .jsQtyInput[data-sku], [data-qty-select-combo][data-sku]',
        );

        if (skuInput && skuInput.dataset.sku) {
          sku = skuInput.dataset.sku;
        }
      }

      /*
       * If we cannot confidently identify
       * this SKU, let Neto operate normally.
       */
      if (!sku) {
        return;
      }

      var currentCartQty = getCartQty(sku);

      var desiredQty = getDesiredQty(area, sku);

      if (!desiredQty || desiredQty < 1) {
        desiredQty = 1;
      }

      // ------------------------------------------
      // PRODUCT NOT CURRENTLY IN CART
      // ------------------------------------------

      if (currentCartQty <= 0) {
        /*
         * Nothing special needed.
         *
         * Neto gets normal desired quantity.
         */
        return;
      }

      // ------------------------------------------
      // ALREADY EXACTLY THIS MANY
      // ------------------------------------------

      if (desiredQty === currentCartQty) {
        event.preventDefault();
        event.stopImmediatePropagation();

        showAlreadyInCart(button, currentCartQty);

        return;
      }

      // ------------------------------------------
      // DESIRED IS LOWER THAN CART
      // ------------------------------------------

      if (desiredQty < currentCartQty) {
        /*
         * Add-to-cart cannot subtract qty.
         *
         * Prevent accidentally adding more.
         */
        event.preventDefault();
        event.stopImmediatePropagation();

        console.log(
          'Cart already contains ' +
            currentCartQty +
            '. Use the cart to reduce quantity.',
        );

        return;
      }

      // ------------------------------------------
      // ADD ONLY THE DIFFERENCE
      // ------------------------------------------

      var qtyToAdd = desiredQty - currentCartQty;

      var netoQty = getNetoQtyInput(area, sku);

      if (!netoQty) {
        /*
         * Don't interfere if we cannot find
         * Neto's actual quantity field.
         */
        console.warn('Could not find Neto quantity input for:', sku);

        return;
      }

      /*
       * Remember what the customer selected.
       * After a successful add we'll display
       * the actual new cart total.
       */
      pendingAdds.set(normaliseSku(sku), {
        desiredQty: desiredQty,

        qtyToAdd: qtyToAdd,
      });

      /*
       * Neto now receives only the difference.
       *
       * Example:
       *
       * Cart = 8
       * Desired = 10
       * Neto qty input = 2
       */
      netoQty.value = String(qtyToAdd);
    },
    true,
  );

  // --------------------------------------------------
  // SYNC PDP FROM REAL CART
  // --------------------------------------------------

  function syncPdpQty() {
    document
      .querySelectorAll('.jsQtyInput[data-sku]')
      .forEach(function (input) {
        var sku = input.dataset.sku;

        if (!sku) return;

        var cartQty = getCartQty(sku);

        input.value = cartQty > 0 ? String(cartQty) : '1';
      });
  }

  // --------------------------------------------------
  // SYNC LISTING CARDS FROM REAL CART
  // --------------------------------------------------

  function syncListingQty() {
    document
      .querySelectorAll('[data-qty-select-combo][data-sku]')
      .forEach(function (wrapper) {
        var sku = wrapper.dataset.sku;

        if (!sku) return;

        var cartQty = getCartQty(sku);

        var select = wrapper.querySelector('.qty-select-combo__select');

        var custom = wrapper.querySelector('.qty-select-combo__input');

        if (!select) {
          return;
        }

        var area = wrapper.parentElement;

        var netoQty = null;

        if (area) {
          var inputs = area.querySelectorAll('.js-neto-qty[data-sku]');

          for (var i = 0; i < inputs.length; i++) {
            if (normaliseSku(inputs[i].dataset.sku) === normaliseSku(sku)) {
              netoQty = inputs[i];

              break;
            }
          }
        }

        // Not in cart
        if (cartQty <= 0) {
          select.value = '1';

          if (custom) {
            custom.value = '';
            custom.hidden = true;
          }

          if (netoQty) {
            netoQty.value = '1';
          }

          return;
        }

        // Normal option exists
        var optionExists = Array.from(select.options).some(function (option) {
          return option.value === String(cartQty);
        });

        if (optionExists) {
          select.value = String(cartQty);

          if (custom) {
            custom.value = '';
            custom.hidden = true;
          }

          if (netoQty) {
            netoQty.value = String(cartQty);
          }

          return;
        }

        // Custom amount
        var customExists = Array.from(select.options).some(function (option) {
          return option.value === 'custom';
        });

        if (customExists) {
          select.value = 'custom';

          if (custom) {
            custom.value = String(cartQty);

            custom.hidden = false;
          }

          if (netoQty) {
            netoQty.value = String(cartQty);
          }
        }
      });
  }

  // --------------------------------------------------
  // SYNC EVERYTHING
  // --------------------------------------------------

  function syncQtyFromCart() {
    syncPdpQty();
    syncListingQty();

    /*
     * Successful cart operation means
     * any pending delta is finished.
     */
    pendingAdds.clear();
  }

  // --------------------------------------------------
  // NETO SUCCESS CALLBACKS
  // --------------------------------------------------

  if (typeof window.nCartInitCallbacks !== 'undefined') {
    window.nCartInitCallbacks.push(syncQtyFromCart);
  }

  if (typeof window.nAddItemCallbacks !== 'undefined') {
    window.nAddItemCallbacks.push(syncQtyFromCart);
  }

  if (typeof window.nAddMultiItemsCallbacks !== 'undefined') {
    window.nAddMultiItemsCallbacks.push(syncQtyFromCart);
  }

  if (typeof window.nRemoveItemCallbacks !== 'undefined') {
    window.nRemoveItemCallbacks.push(syncQtyFromCart);
  }

  // --------------------------------------------------
  // FALLBACK INITIAL SYNC
  // --------------------------------------------------

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        window.setTimeout(syncQtyFromCart, 0);
      },
      {
        once: true,
      },
    );
  } else {
    window.setTimeout(syncQtyFromCart, 0);
  }
})();
